import React, { useEffect, useState } from "react";
import PrivateLayout from "../../layouts/privateLayout";
import { Box, Button, Stack, useMediaQuery, useTheme } from "@mui/material";
import BasicBreadcrumbs from "../../components/breadcrumb";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Add } from "@mui/icons-material";
import axios from "axios";
import toast from "react-hot-toast";
import { useApiClient } from "../../context/ApiClientContext";
import Listing from "./listing";
import api from "../../helper/baseApi";
import ErrorAlert from "../../helper/errorAlert";


export const DataContext = React.createContext();

const Index = () => {
  const location = useLocation();

  const [showButton, setShowButton] = useState(false);
  const [selectedRows, setRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPage, setTotalPage] = useState();
  const [pageSize, setPageSize] = useState();
  const [selectedIds, setSelectedIds] = useState([]);
  const { apiUrls: { mobileApiUrl } } = useApiClient();
  const [filteredDataList, setFilteredDataList] = useState([]);
  const navigate = useNavigate();

  const handleShowButton = (ids) => {
    setSelectedIds(ids);
    setShowButton(ids.length > 0);
  };

  useEffect(() => {
    fetchData();
  }, [location.pathname]);

  const fetchData = async () => {
    try {
      // const apiUrl = `${mobileApiUrl}point/view`;
      // const response = await api.get(apiUrl);

      // const jobGradeList = response?.data?.data?.jobGradeList || [];

      // const dataWithKeys = jobGradeList.map((item) => {
      //   let jobGrade = "";
      //   let description = item.name?.trim() || "";

      //   if (item.name && item.name.includes("-")) {
      //     const [grade, ...descParts] = item.name.split("-");
      //     jobGrade = grade.trim().replace(/\s+/g, " ");
      //     description = descParts.join("-").trim().replace(/\s+/g, " ");
      //   } else {
      //     description = item.name?.trim() || "";
      //   }

      //   return {
      //     ...item, // ✅ keeps updatedBy, updatedDate, createdBy, createdDate
      //     id: item.jobGradeId,
      //     jobGrade,
      //     description,
      //     // createdDate: item.createdDate,
      //     // createdDateFormatted: formatDate(item.createdDate),
      //   };
      // });

      // setFilteredDataList(dataWithKeys);
    } catch (error) {
      ErrorAlert(error, navigate);
    }
  };

  return (
    <PrivateLayout>
      <Box sx={{ mx: "40px", mt: 5 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 2,
            mb: 3,
          }}
        >
          <BasicBreadcrumbs first="Employee Earned point" />
        </Box>
          <Listing
            dataList={filteredDataList}
            currentPage={currentPage}
            totalPage={totalPage}
            pageSize={pageSize}
            handleShowButton={handleShowButton}
          />
      </Box>
    </PrivateLayout>
  );
};

export default Index;
